/**
 * Returns whether `targetWindow` exposes the browser WebMCP API.
 *
 * Access can throw for cross-origin or otherwise inaccessible windows, so those
 * windows are treated as unsupported.
 */ export const isWebMcpSupported = (targetWindow)=>{
    try {
        var _targetWindow_document_modelContext;
        return typeof ((_targetWindow_document_modelContext = targetWindow.document.modelContext) === null || _targetWindow_document_modelContext === void 0 ? void 0 : _targetWindow_document_modelContext.registerTool) === 'function';
    } catch (_error) {
        return false;
    }
};

//# sourceMappingURL=isWebMcpSupported.js.map